import apiHelper from '../utils/apiHelper';

export const daireService = {
    // Get all usage records
    getUsage: async () => {
        try {
            const response = await apiHelper.get('/api/daire/usage');
            return response.data;
        } catch (error) {
            console.error('Error fetching Daire usage:', error);
            throw error;
        }
    },

    // Get usage summary statistics
    getUsageSummary: async () => {
        try {
            const response = await apiHelper.get('/api/daire/usage/summary');
            return response.data;
        } catch (error) {
            console.error('Error fetching Daire usage summary:', error);
            throw error;
        }
    },

    // Track new usage
    trackUsage: async (usageData) => {
        try {
            const response = await apiHelper.post('/api/daire/track-usage', usageData);
            return response.data;
        } catch (error) {
            console.error('Error tracking Daire usage:', error);
            throw error;
        }
    },

    // Get all suggestions
    getSuggestions: async () => {
        try {
            const response = await apiHelper.get('/api/daire/suggestions');
            return response.data;
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            throw error;
        }
    },

    // Create new suggestion
    createSuggestion: async (suggestionData) => {
        try {
            const response = await apiHelper.post('/api/daire/suggestions', suggestionData);
            return response.data;
        } catch (error) {
            console.error('Error creating suggestion:', error);
            throw error;
        }
    },

    // Update suggestion
    updateSuggestion: async (id, suggestionData) => {
        try {
            const response = await apiHelper.post(`/api/daire/suggestions/${id}`, suggestionData);
            return response.data;
        } catch (error) {
            console.error('Error updating suggestion:', error);
            throw error;
        }
    },

    // Delete suggestion
    deleteSuggestion: async (id) => {
        try {
            const response = await apiHelper.delete(`/api/daire/suggestions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting suggestion:', error);
            throw error;
        }
    },

    // Get Daire options
    getOptions: async () => {
        try {
            const response = await apiHelper.get('/api/daire/options');
            return response.data;
        } catch (error) {
            console.error('Error fetching Daire options:', error);
            throw error;
        }
    },

    // Update Daire option
    updateOption: async (id, value) => {
        try {
            const response = await apiHelper.post(`/api/daire/options/${id}`, { value });
            return response.data;
        } catch (error) {
            console.error('Error updating Daire option:', error);
            throw error;
        }
    }
}; 